/**
 * A single rubric-criterion row: label + horizontal progress bar + score.
 * `fill` picks the bar color: "green" | "orange" | "red".
 */
function CriteriaRow({ label, widthPct, score, fill = "green" }) {
  return (
    <div className="ul-criteria-row">
      <span className="ul-criteria-label">{label}</span>
      <div className="ul-criteria-bar-wrap">
        <div className={`ul-criteria-fill ul-fill-${fill}`} style={{ width: `${widthPct}%` }} />
      </div>
      <span className="ul-criteria-score">{score}</span>
    </div>
  );
}

export default CriteriaRow;
